import { OperatingTime } from '~/types/common';

import checkValidPreOrderTime from './checkValidPreOrderTime';

export default function isCanPreOrderTime(
  operatingTime: OperatingTime,
  afterHours: number,
  beforeHours: number,
  pickMealTime: Date | null,
  now: Date,
): boolean {
  const [isValid] = checkValidPreOrderTime(
    operatingTime,
    afterHours,
    beforeHours,
    pickMealTime,
    now,
  );

  return isValid;
}
